import { useEffect, useState } from "react";
import Common from "../../../helper/common";
import AdvanceTable from "../../../components/advanceTable";
import { AppInput } from "../../../components/appComponents";
import { useNavigate } from "react-router-dom";
import { useQueryParams } from "../../../contexts/queryParamsContext";
import { Button } from "../../../components/ui/button";
import { TaxTypeEnum, respEnum } from "../../../constants/appConstant";

const TaxLogs = () => {
  const [data, setData] = useState({});
  const [fromDate, setfromDate] = useState(null);
  const [tillDate, settillDate] = useState(null);

  const navigate = useNavigate();
  const { params, setParams } = useQueryParams();

  useEffect(() => {
    getData(1);
  }, [fromDate, tillDate]);

  const resetFilters = () => {
    setfromDate(null);
    settillDate(null);
  };

  const getData = async (pageNumber, recordsToDisplay = null) => {
    try {
      const response = await Common.ApiService.getInstance().request(
        "GetTaxLogs",
        {
          pageNumber,
          fromDate, // backend expects fromDate
          tillDate, // backend expects tillDate
          recordsToDisplay,
        },
        "Post"
      );

      if (response?.status === respEnum.Success && response?.data) {
        const obj = {
          ...response.data[0],
          data: response.data[0].data.map((item) => ({
            ...item,
            type:
              item.type === TaxTypeEnum.Inclusive
                ? "Inclusive"
                : item.type === TaxTypeEnum.Exclusive
                ? "Exclusive"
                : item.type,
            percentage: item.percentage ? `${item.percentage}%` : "0%",
            amount: item.amount ?? 0,
            createdon: Common.Utility.ConvertTime(item.createdon),
          })),
        };
        setData(obj);
      }
    } catch (error) {
      console.error("Error fetching tax logs:", error);
      Common.SweetAlert.alert("Failed to load tax logs", "error");
    }
  };

  const actions = [
    {
      type: "view",
      onClick: (val) => {
        setParams({ ...params, bookingId: val.booking_id });
        navigate("/app/bookingDetails");
      },
    },
  ];

  const columns = [
    { title: "Tax Name", type: "text", key: "name" },
    { title: "Tax Type", type: "text", key: "type" },
    { title: "Percentage %", type: "text", key: "percentage" },
    { title: "Tax Amount", type: "number", key: "amount", showTotal: true },
    { title: "Created On", type: "text", key: "createdon" },
  ];

  return (
    <>
      {/* 🔹 Filters */}
      <div className="md:grid md:grid-cols-6 gap-3 mb-3">
        <AppInput
          type="date"
          value={fromDate}
          onChange={(e) => {
            const selectedDate = e;
            if (tillDate && new Date(selectedDate) > new Date(tillDate)) {
              Common.showToast(
                "From Date must be lesser than Till Date",
                "Error",
                "info"
              );
              setfromDate(null);
            } else setfromDate(selectedDate);
          }}
          label="From"
          className="col-span-1"
        />

        <AppInput
          type="date"
          value={tillDate}
          onChange={(e) => {
            const selectedDate = e;
            if (fromDate && new Date(selectedDate) < new Date(fromDate)) {
              Common.showToast(
                "Till Date must be greater than From Date",
                "Error",
                "info"
              );
              settillDate(null);
            } else settillDate(selectedDate);
          }}
          label="Till"
          className="col-span-1"
        />

        <Button className="lg:mt-6 h-8 mb-5" onClick={resetFilters}>
          Reset Filters
        </Button>
      </div>

      {/* 🔹 Table */}
      {data?.data && (
        <AdvanceTable
          title="Tax Logs"
          columns={columns}
          data={data}
          getData={getData}
          showPagination
          showAddButton={false}
          actionButtons={actions}
          showExportoptions
          exportFileName={"Tax Logs"}
        />
      )}
    </>
  );
};

export default TaxLogs;
